import { render, staticRenderFns } from "./AddMaterialSlot.vue?vue&type=template&id=0e6cf492&scoped=true"
import script from "./AddMaterialSlot.vue?vue&type=script&lang=ts"
export * from "./AddMaterialSlot.vue?vue&type=script&lang=ts"
import style0 from "./AddMaterialSlot.vue?vue&type=style&index=0&id=0e6cf492&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6cf492",
  null
  
)

export default component.exports